import React from "react";
import { LazyChunkBoundary } from "@design-system/LazyChunkBoundary/LazyChunkBoundary";
import { DesignTokensPlayground } from "../DesignTokensPlayground";
import { designTokenTabs, DesignTokenTabId } from "../designTokensCatalog";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

const IconsCatalogPlayground = React.lazy(() =>
    import("../iconsCatalog/IconsCatalogPlayground").then((module) => ({
        default: module.IconsCatalogPlayground,
    })),
);

const designTokenDescriptions: Record<DesignTokenTabId, string> = {
    "primitive-colors":
        "Primitive color scales. Select a token to copy its CSS reference.",
    "semantic-colors":
        "Semantic color roles and the primitive tokens they resolve to.",
    spacing: "Spacing scale tokens for gaps, padding, and margins.",
    "border-widths": "Border width tokens.",
    radius: "Corner radius tokens.",
    shadows: "Shadow tokens for elevation.",
    motion: "Easing and duration tokens for transitions. Select a sample to replay it.",
    font: "Font family, size, weight, and tracking tokens.",
    typography: "Typography mixins. Select a mixin to copy its Sass include.",
};

export const designTokenEntries: PlaygroundComponentEntry[] = [
    ...designTokenTabs.map((tab): PlaygroundComponentEntry => ({
        id: tab.id,
        label: tab.label,
        description: designTokenDescriptions[tab.id],
        group: "design-tokens",
        render: () => <DesignTokensPlayground tab={tab} />,
    })),
    {
        id: "icons",
        label: "Icons",
        description:
            "Every icon in the library, grouped by folder. Select an icon to copy its import.",
        group: "design-tokens",
        render: () => (
            <LazyChunkBoundary>
                <IconsCatalogPlayground />
            </LazyChunkBoundary>
        ),
    },
];
